import styled from 'styled-components';

import { ActivityCenterWrapper } from '@xing-com/crate-activity-center-wrapper';
import { Header } from '@xing-com/crate-layout-header';
import { useDeviceInfo } from '@xing-com/crate-xinglet';
import { Section } from '@xing-com/layout-primitives';
import { BottomBar } from '@xing-com/platform-layout-bottom-bar';
import { Footer } from '@xing-com/platform-layout-footer';
import { xdlColorBackground } from '@xing-com/tokens';
import { useMediaListener, BREAKPOINTS } from '@xing-com/util';

import { HeaderLoggedOutWithLoginLink } from './header-logged-out-with-login-link';

const StyledLayoutWrapper = styled.div`
  background-color: ${xdlColorBackground};
`;

type UnifiedLayoutProps = {
  layout: 'xing-unified' | 'xing-gridless';
  isLoggedInLayout: boolean;
  loginDestination?: string;
  loginTracking?: string;
};

export const UnifiedLayout: React.FC<
  React.PropsWithChildren<UnifiedLayoutProps>
> = ({
  children,
  layout,
  isLoggedInLayout,
  loginDestination,
  loginTracking,
}) => {
  const breakpoint = useMediaListener();
  const isNotHandheld = breakpoint !== BREAKPOINTS.handheld;

  const { isWebview } = useDeviceInfo();

  const hasFooter = !isLoggedInLayout || isNotHandheld;

  return (
    <>
      {isLoggedInLayout ? null : <ActivityCenterWrapper />}
      <StyledLayoutWrapper data-qa="core-crate-layout-main">
        {isLoggedInLayout ? (
          <Header />
        ) : (
          <HeaderLoggedOutWithLoginLink
            loginDestination={loginDestination}
            loginTracking={loginTracking}
          />
        )}
        <main id="content">
          {layout === 'xing-gridless' ? (
            <Section noBlockPadding>{children}</Section>
          ) : (
            children
          )}
        </main>
        {hasFooter ? <Footer homeLink="/" /> : null}
        {!isWebview ? <BottomBar /> : null}
      </StyledLayoutWrapper>
    </>
  );
};
